import { useState, useEffect } from 'react';
import { Users, Phone, Calendar, MessageSquare, Search, Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';
import API from '../services/api';

function Contacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadContacts();
  }, []);

  const loadContacts = async () => {
    try {
      setLoading(true);
      const response = await API.get('/contacts');
      setContacts(response.data.data);
    } catch (error) {
      toast.error('Failed to load contacts');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const filteredContacts = contacts.filter(contact =>
    contact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    contact.phone.includes(searchTerm)
  );

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-content">
         <div className="loading-spinner">
  <Loader2 size={48} style={{ animation: 'spin 1s linear infinite', color: '#1e3a5f' }} />
</div>
<p className="loading-text">Loading contacts...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dash-page">
      <div className="dash-header">
        <div>
<h1 className="dash-title" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
  <Users size={26} color="#1e3a5f" /> Contacts
</h1>
          <p className="dash-subtitle">Manage your WhatsApp contacts and conversations</p>
        </div>
      </div>

      <div className="dash-card">
        <div className="mb-lg contacts-search-wrap">
  <Search size={16} className="contacts-search-icon" />
  <input
    type="text"
    placeholder="Search by name or phone..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    className="search-bar contacts-search-input"
  />
</div>

        {filteredContacts.length > 0 ? (
          <div className="table-container table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>
  <span style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
    <Users size={14} /> Name
  </span>
</th>
<th>
  <span style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
    <Phone size={14} /> Phone
  </span>
</th>
<th>
  <span style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
    <Calendar size={14} /> Joined
  </span>
</th>
<th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredContacts.map((contact, index) => (
                  <tr key={contact.id}>
                    <td>
                      <div className="contact-name-cell">
                        <div className={`avatar ${index % 2 === 0 ? 'avatar-gradient-primary' : 'avatar-gradient-pink'}`}>
                          {contact.name.charAt(0).toUpperCase()}
                        </div>
                        <span className="contact-name-text">{contact.name}</span>
                      </div>
                    </td>
                    <td>{contact.phone}</td>
                    <td>
                      {new Date(contact.created_at).toLocaleDateString('en-US', {
                        year: 'numeric', month: 'short', day: 'numeric'
                      })}
                    </td>
                    <td>
                      <button
  onClick={() => window.location.href = '/messages'}
  className="btn btn-info btn-sm contacts-msg-btn"
>
  <MessageSquare size={13} /> Message
</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="empty-state">
<div className="empty-state-icon">
  <Users size={64} color="#cbd5e1" />
</div>            <h3 className="empty-state-title">
              {searchTerm ? 'No Contacts Found' : 'No Contacts Yet'}
            </h3>
            <p className="empty-state-description">
              {searchTerm ? 'Try a different search term' : 'Contacts will appear here when users message you'}
            </p>
          </div>
        )}
      </div>

      <div className="responsive-grid-2 mt-lg">
        <div className="stat-footer-card">
          <div className="stat-footer-label">Total Contacts</div>
          <div className="stat-footer-value">{contacts.length}</div>
        </div>
        <div className="stat-footer-card">
          <div className="stat-footer-label">Showing</div>
          <div className="stat-footer-value">{filteredContacts.length}</div>
        </div>
      </div>
    </div>
  );
}

export default Contacts;